import { AfterContentInit, Component, OnDestroy } from '@angular/core';
import { UserInfoWithId, UserTableService } from 'src/app/core/database/user-table.service';
import { FrillServiceService } from 'src/app/core/frill-widget/frill-service.service';

@Component({
  selector: 'frill-widget',
  templateUrl: './frill-widget.component.html',
  styleUrls: ['./frill-widget.component.scss'],
})
export class FrillWidgetComponent implements AfterContentInit, OnDestroy {
  widget?: FrillWidget;
  config?: FrillConfig;
  currentUser: UserInfoWithId;

  constructor(
    private readonly frillService: FrillServiceService,
    private readonly userTableService: UserTableService
  ) {}

  ngAfterContentInit(): void {
    this.userTableService.get(1).then((result) => {
      this.currentUser = result;
      this.frillService.getToken().subscribe((token) => {
        this.config = {
          key: 'a498f6f4-c4a7-4700-bdc6-8ebd0525ba33',
          callbacks: {
            onReady: (frillWidget) => {
              this.widget = frillWidget;
            },
          },
          ssoToken: token,
        };
        window.Frill_Config = window.Frill_Config || [];
        window.Frill_Config.push(this.config);

        if ('Frill' in window) {
          this.widget = window.Frill.widget(this.config);
        }
      });
    });
  }

  ngOnDestroy(): void {
    this.widget?.destroy();
    window.Frill_Config = window.Frill_Config.filter((c) => c !== this.config);
  }
}
